// Autobahn (auto.de redesign) — saved-search card, ADV-267 (Figma "mcard acc-search").
//
// Same data + handlers as before (getCount, updateSavedSearchString email-alert,
// deleteSavedSearchString, see-results → SRP); only the markup follows Figma: make/model title with
// the Aktiv/Pausiert status chip (= email alert on/off), the other criteria, Ausgeführt / Läuft ab /
// Treffer and the actions row. A paused search has no expiry date (user-actions clears expiresAt
// together with emailAlert), so "Läuft ab" shows a dash there.
import * as React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { MANUFACTURER_KEY, MODEL_KEY, SERIES_KEY, SUB_MODEL_KEY } from '../../../../framework/constants/search';
import { formatTimestamp, getChipFilterValue, getFormattedPrice } from '@bytebrand/fe-ui-core-autobahn/utils';
import trashIcon from '../icons/trash.svg';
import activeDot from '../icons/status-active.svg';
import pausedDot from '../icons/status-paused.svg';
// the make/model group (Modell lists series rows like "3er Reihe" as SERIES), in reading order
const VEHICLE_KEYS = [MANUFACTURER_KEY, SERIES_KEY, MODEL_KEY, SUB_MODEL_KEY];
const SavedSearchCardNext = ({ t, searchString: { filters }, expiresAt, emailAlert, timestamp, _id, addNotification, updateSavedSearchString, deleteSavedSearchString, history, searchString, searchStore, language, }) => {
    const [offers, setOffers] = React.useState(0);
    React.useEffect(() => {
        searchStore.getCount({ filters }, true).then((count = 0) => setOffers(count));
    }, [searchString.query]);
    const absolutValues = _get(filters, 'absolutValues', {});
    const { chipList = [] } = searchString;
    // Figma: the vehicle ("Make, Model") as the title, the remaining filters below it; a search over
    // several vehicles ("Weiteres Fahrzeug" groups) reads "BMW, 3er Reihe / Audi, A4"
    const titleChips = _isEmpty(absolutValues) ? [] : chipList.filter((c) => VEHICLE_KEYS.includes(c.filterKey));
    const vehicles = [];
    [...titleChips]
        .sort((a, b) => VEHICLE_KEYS.indexOf(a.filterKey) - VEHICLE_KEYS.indexOf(b.filterKey))
        .forEach((c) => { const i = c.index || 0; (vehicles[i] = vehicles[i] || []).push(getChipFilterValue(c, t, language)); });
    const queryTitle = vehicles.filter(Boolean).map((parts) => parts.join(', ')).join(' / ') || t('anyMake');
    const criteria = chipList.filter((c) => !titleChips.includes(c))
        .map((c) => getChipFilterValue(c, t, language)).join(', ');
    const handleToggleEmailAlert = () => updateSavedSearchString(_id, { emailAlert: !emailAlert })
        .catch(() => addNotification({ message: t('updateSearchStringError'), level: 'error' }));
    const handleDelete = () => deleteSavedSearchString(_id)
        .catch(() => addNotification({ message: t('deleteSearchStringError'), level: 'error' }));
    const handleSeeResults = () => {
        searchStore.clearSearchState();
        history.push({ pathname: '/search', search: searchString.query, from: history.location });
    };
    return (React.createElement("article", { className: "as-card" },
        React.createElement("div", { className: "as-card-head" },
            React.createElement("h3", { className: "as-card-title" }, queryTitle),
            React.createElement("span", { className: `as-chip${emailAlert ? ' as-chip--active' : ''}` },
                React.createElement("img", { className: "as-chip-dot", src: emailAlert ? activeDot : pausedDot, alt: "", width: 8, height: 8 }),
                emailAlert ? t('statusActive') : t('statusPaused'))),
        React.createElement("div", { className: "as-rule" }),
        React.createElement("p", { className: "as-criteria" }, criteria),
        React.createElement("dl", { className: "as-stats" },
            React.createElement("div", { className: "as-stat" },
                React.createElement("dt", null, t('statExecuted')),
                React.createElement("dd", null, formatTimestamp({ timestamp, format: 'DD.MM.YYYY' }))),
            React.createElement("div", { className: "as-stat" },
                React.createElement("dt", null, t('statExpires')),
                React.createElement("dd", null, expiresAt && emailAlert ? formatTimestamp({ timestamp: expiresAt, format: 'DD.MM.YYYY' }) : '—')),
            React.createElement("div", { className: "as-stat" },
                React.createElement("dt", null, t('statMatches')),
                React.createElement("dd", null, offers ? getFormattedPrice(offers) : 0))),
        React.createElement("div", { className: "as-spacer" }),
        React.createElement("div", { className: "as-card-foot" },
            React.createElement("button", { type: "button", className: "as-delete", onClick: handleDelete, "aria-label": t('deleteSearch'), title: t('deleteSearch') },
                React.createElement("span", { className: "as-delete-icon" },
                    React.createElement("img", { src: trashIcon, alt: "", width: 15.3, height: 13.8 }))),
            React.createElement("button", { type: "button", className: "as-text-btn", onClick: handleToggleEmailAlert }, emailAlert ? t('pause') : t('resume')),
            React.createElement("button", { type: "button", className: "as-text-btn as-text-btn--grow", disabled: !offers, onClick: handleSeeResults }, t('seeResults')))));
};
export default SavedSearchCardNext;
